"use client";

import { useEffect } from "react";
import { initFrvrOnce, runFrvrBootstrapper } from "@/lib/frvr/initFrvr";

/**
 * Wires FRVR config, lifecycle, init, and bootstrapper once after CDN scripts load.
 */
export function FrvrRoot() {
  useEffect(() => {
    initFrvrOnce();
    void runFrvrBootstrapper();
  }, []);
  return null;
}
